import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-50daee6b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"padding-bottom":"30px"} }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"12px","font-weight":"600"} }, " 回答配置 ", -1))
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DecorateModalTitle = _resolveComponent("DecorateModalTitle")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_textarea = _resolveComponent("a-textarea")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_radio = _resolveComponent("a-radio")!
  const _component_a_radio_group = _resolveComponent("a-radio-group")!
  const _component_a_divider = _resolveComponent("a-divider")!
  const _component_Config = _resolveComponent("Config")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_ProblemSub = _resolveComponent("ProblemSub")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_drawer = _resolveComponent("a-drawer")!

  return (_openBlock(), _createBlock(_component_a_drawer, {
    placement: "right",
    visible: _ctx.visible,
    "onUpdate:visible": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.visible) = $event)),
    onClose: _ctx.onClose,
    width: "800px;",
    class: "problem_drawer",
    destroyOnClose: true
  }, {
    title: _withCtx(() => [
      _createVNode(_component_DecorateModalTitle, { modalTitle: "任务问题配置" })
    ]),
    default: _withCtx(() => [
      _createVNode(_component_a_form, {
        model: _ctx.previewItem,
        rules: _ctx.rules,
        ref: "formRef",
        "label-col": { style: { width: '96px' } }
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_a_form_item, { label: "题目编号" }, {
              default: _withCtx(() => [
                _createElementVNode("div", null, _toDisplayString(_ctx.previewIndex + 1), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              label: "题型",
              name: "itemType"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_select, {
                  placeholder: "请选择...",
                  style: {"width":"240px"},
                  value: _ctx.previewItem.itemType,
                  "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.previewItem.itemType) = $event)),
                  options: _ctx.typeOptions,
                  disabled: _ctx.disableType
                }, null, 8, ["value", "options", "disabled"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              label: "题目",
              name: "title"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_textarea, {
                  style: {"width":"480px"},
                  placeholder: "请输入...",
                  value: _ctx.previewItem.title,
                  "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.previewItem.title) = $event)),
                  valueModifiers: { trim: true },
                  maxlength: 200,
                  showCount: "",
                  allowClear: ""
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            (
            _ctx.previewItem.itemType !== 'radio' &&
              _ctx.previewItem.itemType !== 'checkbox' &&
              _ctx.previewItem.itemType !== 'picture' &&
              _ctx.previewItem.itemType !== 'multiplepictures'
          )
              ? (_openBlock(), _createBlock(_component_a_form_item, {
                  key: 0,
                  label: "填写提示",
                  name: "tips"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_input, {
                      style: {"width":"360px"},
                      placeholder: "请输入...",
                      value: _ctx.previewItem.tips,
                      "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.previewItem.tips) = $event)),
                      valueModifiers: { trim: true },
                      maxlength: 200,
                      allowClear: "",
                      size: "small"
                    }, null, 8, ["value"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (
            _ctx.previewItem.itemType !== 'radio' &&
              _ctx.previewItem.itemType !== 'checkbox' &&
              _ctx.previewItem.itemType !== 'picture' &&
              _ctx.previewItem.itemType !== 'multiplepictures'
          )
              ? (_openBlock(), _createBlock(_component_a_form_item, {
                  key: 1,
                  label: "提示文案",
                  name: "sampleText"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_textarea, {
                      style: {"width":"360px"},
                      placeholder: "请输入...",
                      value: _ctx.previewItem.sampleText,
                      "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.previewItem.sampleText) = $event)),
                      valueModifiers: { trim: true },
                      maxlength: 200,
                      showCount: "",
                      allowClear: ""
                    }, null, 8, ["value"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_a_form_item, {
              label: "是否必填",
              name: "isMust"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_radio_group, {
                  name: "isMust",
                  value: _ctx.previewItem.isMust,
                  "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.previewItem.isMust) = $event))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_radio, { value: 1 }, {
                      default: _withCtx(() => [
                        _createTextVNode("是")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_radio, { value: 0 }, {
                      default: _withCtx(() => [
                        _createTextVNode("否")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["value"])
              ]),
              _: 1
            })
          ]),
          _createVNode(_component_a_divider, null, {
            default: _withCtx(() => [
              _hoisted_2
            ]),
            _: 1
          }),
          _createVNode(_component_Config, {
            item: _ctx.previewItem,
            optionKey: _ctx.optionKey
          }, null, 8, ["item", "optionKey"]),
          _createVNode(_component_ProblemSub, { class: "problemSub" }, {
            default: _withCtx(() => [
              (_ctx.per && _ctx.previewIndex > 0 && _ctx.previewIndex > _ctx.perDisabledIndex)
                ? (_openBlock(), _createBlock(_component_a_button, {
                    key: 0,
                    style: {"margin-right":"12px"},
                    disabled: _ctx.previewIndex <= _ctx.perDisabledIndex,
                    loading: _ctx.$store.state.loadingStatus,
                    onClick: _ctx.onPer
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" 上一题 "),
                      (_ctx.keepItem !== JSON.stringify(_ctx.previewItem))
                        ? (_openBlock(), _createElementBlock("span", _hoisted_3, "（提交）"))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }, 8, ["disabled", "loading", "onClick"]))
                : _createCommentVNode("", true),
              (_ctx.next)
                ? (_openBlock(), _createBlock(_component_a_button, {
                    key: 1,
                    style: {"margin-right":"12px"},
                    ghost: "",
                    type: "primary",
                    onClick: _ctx.onNext,
                    loading: _ctx.$store.state.loadingStatus,
                    disabled: 
            (_ctx.previewIndex > _ctx.formState[_ctx.problemKey].length - 1 &&
              _ctx.keepItem === JSON.stringify(_ctx.previewItem)) ||
              _ctx.previewIndex + 1 >= _ctx.$store.state.config.problemNum ||
              _ctx.nextDisabledIndex <= _ctx.previewIndex
          
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" 下一题 "),
                      (_ctx.keepItem !== JSON.stringify(_ctx.previewItem))
                        ? (_openBlock(), _createElementBlock("span", _hoisted_4, "（提交）"))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }, 8, ["onClick", "loading", "disabled"]))
                : _createCommentVNode("", true),
              _createVNode(_component_a_button, {
                type: "primary",
                onClick: _ctx.submit,
                disabled: _ctx.disabled || _ctx.keepItem === JSON.stringify(_ctx.previewItem),
                loading: _ctx.$store.state.loadingStatus
              }, {
                default: _withCtx(() => [
                  _createTextVNode("完成")
                ]),
                _: 1
              }, 8, ["onClick", "disabled", "loading"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model", "rules"])
    ]),
    _: 1
  }, 8, ["visible", "onClose"]))
}